export function mapBackgroundClass(color?: string | number): string {
    switch (color) {
        case 'grey':
            return 'bg-grey-50';
        case 'blue':
            return 'bg-blue-50';
        case 'pink':
            return 'bg-blue-50';
        default:
            return 'bg-white';
    }
}

export function transformBackgroundClassToText(
    color?: string | number
): string {
    switch (color) {
        case 'bg-grey-50':
            return 'text-grey-50';
        case 'bg-grey-100':
            return 'text-grey-100';
        case 'bg-blue-50':
            return 'text-blue-50';
        case 'bg-red-100':
            return 'text-red-100';
        default:
            return 'text-white';
    }
}
